export const developData = (initialStructure) => {
  return Array.isArray(initialStructure)
    ? initialStructure.map((row) => {
        return {
          ...row,
          serviceCategory: row?.serviceCategory?.label,
          serviceType: row?.serviceType?.label,

          // TODO: extract from payload coming from backend soon
          location: 'All locations',
        };
      })
    : [];
};
